import { varIsIn, varOptions } from "common/var";
import {
  Button,
  Col,
  DatePicker,
  FormItem,
  Modal,
  Popconfirm,
  Row,
  Select,
  SuccessNotification,
  message,
} from "components/common";
import { useEffect, useState } from "react";
import { callPutApiWithAuth } from "utils/api";
import { Wrapper } from "./EditModal.styled";

export default function EditModal(props) {
  const [formData, setFormData] = useState({
    quantity: 1,
    pay_cycle: "",
  });
  const [isUpdating, setIsUpdating] = useState(false);

  const onUpdateDone = (res) => {
    SuccessNotification(res.message);
    setIsUpdating(false);
    props.setShouldLoad(true);
    props.setIsEdition(false);
  };
  const onUpdateFail = () => {
    setIsUpdating(false);
  };
  const handleUpdate = () => {
    // Validation

    if (!formData.pay_cycle) {
      message.error("Please input pay cycle");
      return;
    }

    if (!formData.next_date) {
      message.error("Please select next date");
      return;
    }

    setIsUpdating(true);
    callPutApiWithAuth(
      `my_account/subscription/next_date/${props.data.id}`,
      { ...formData },
      onUpdateDone,
      onUpdateFail
    );
  };

  useEffect(() => {
    setFormData({
      ...formData,
      pay_cycle: props.data.pay_cycle,
      next_date: props.data.next_date,
    });
  }, [props.data]);

  return (
    <Modal width={480} onCancel={() => props.setIsEdition(false)}>
      <Wrapper>
        <div className="modal-new-title">Edit Subscription Billing Date</div>
        <Row gutter={[20, 10]}>
          {varIsIn("product.type", props.data.product.type, [
            "physical",
            "ticket",
          ]) ? (
            <>
              <Col xs={24} sm={12}>
                <div className="input-container">
                  <FormItem>
                    <DatePicker
                      label={"Next Date"}
                      value={formData.next_date}
                      onChange={(e) =>
                        setFormData({ ...formData, next_date: e })
                      }
                    />
                  </FormItem>
                </div>
              </Col>
              <Col xs={24} sm={12}>
                <div className="input-container">
                  <FormItem>
                    <Select
                      value={formData.pay_cycle}
                      onChange={(v) =>
                        setFormData({ ...formData, pay_cycle: v })
                      }
                      label="Frequency"
                      options={varOptions("subscription.payCycle").filter(
                        (el) => {
                          return (
                            props.data.product.pay_cycles.filter(
                              (el2) => el2 * 1 === el.value
                            ).length > 0
                          );
                        }
                      )}
                    />
                  </FormItem>
                </div>
              </Col>
            </>
          ) : (
            <>
              <Col xs={24}>
                <div className="input-container">
                  <FormItem>
                    <Select
                      label={"Frequency"}
                      value={formData.pay_cycle}
                      onChange={(v) =>
                        setFormData({ ...formData, pay_cycle: v })
                      }
                      options={varOptions("subscription.payCycle").filter(
                        (el) => {
                          return (
                            props.data.product.pay_cycles.filter(
                              (el2) => el2 * 1 === el.value
                            ).length > 0
                          );
                        }
                      )}
                      style={{ width: "100%" }}
                    />
                  </FormItem>
                </div>
              </Col>
            </>
          )}

          <Col span={24}>
            <div className="action-btn">
              <Button
                className="cancel-btn"
                onClick={() => props.setIsEdition(false)}
              >
                Cancel
              </Button>
              <Popconfirm onConfirm={handleUpdate}>
                <Button loading={isUpdating} className="create-btn">
                  Update Subscription
                </Button>
              </Popconfirm>
            </div>
          </Col>
        </Row>
      </Wrapper>
    </Modal>
  );
}
